<template>
  <div id="modalOverlay" class="modal-overlay">
    <div class="modal-content">
      <div class="modal-card">
        <div :class="`banner lvl_${userDetails.level}`"></div>
        <div class="content">
          <h1><b>{{ modalTitle }}</b></h1>
          <p>{{ modalMessage }}</p>

          <div class="outline_fancy_btn play">
            <button type="" class="fancy_btn close_modal">{{ getTranslations.home_level_continue }}</button>
          </div>
        </div>
      </div>
      <div class="outer-modal-card">
        <div class="outline_fancy_btn blue">
          <button type="" class="fancy_btn close_modal" @click.prevent="toLevelPage">{{ getTranslations.home_level_more }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState, mapActions, mapMutations} from 'vuex';



export default {
  name: 'level-modal',
  props: {
    level: {
      type: Number,
      required: true,
    }
  },
  computed: {
    ...mapState('common', [
      'userDetails',
    ]),
    ...mapState('profile', [
      'jwtInVuex',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
      modalTitle() {
        switch (this.userDetails.level) {
          case 1:
            return this.getTranslations.home_level_title_1;
          case 2:
            return this.getTranslations.home_level_title_2;
          case 3:
            return this.getTranslations.home_level_title_3;
          case 4:
            return this.getTranslations.home_level_title_4;
          default:
            return this.getTranslations.home_level_title_1;
        }
      },

      modalMessage() {
        switch (this.userDetails.level) {
          case 1:
            return this.getTranslations.home_level_desc_1;
          case 2:
            return this.getTranslations.home_level_desc_2;
          case 3:
            return this.getTranslations.home_level_desc_3;
          case 4:
            return this.getTranslations.home_level_desc_4;
          default:
            return this.getTranslations.home_level_desc_1;
        }
      },
  },
  methods:{
    toLevelPage() {
      this.$router.push('/home/levels');
    },
  },
};

</script>



// WEBPACK FOOTER //
// src/components/home/modals/LevelModal.vue